var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-ai-robot",
      class: { "is-fullscreen": _vm.bFullscreen, "is-max": _vm.max },
    },
    [
      _c(
        "draggable-container",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: !_vm.scriptLoaded,
              expression: "!scriptLoaded",
            },
          ],
          staticClass: "yxtbiz-ai-robot--container",
          attrs: {
            "yxt-loading-background": "rgba(255, 255, 255, 0)",
            bFullscreen: _vm.bFullscreen,
          },
          on: {
            resize: function () {
              return _vm.$refs.msgDialog.scrollToEnd()
            },
          },
        },
        [
          _vm.scriptLoaded
            ? [
                _c("broadside", {
                  attrs: {
                    visible: _vm.chatListVisible,
                    title: _vm.title,
                    waitAnswer: _vm.waitAnswer,
                    "small-client": !_vm.bFullscreen,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.chatListVisible = $event
                    },
                    selectChat: _vm.selectChat,
                  },
                }),
                _c("msg-dialog", {
                  ref: "msgDialog",
                  class: {
                    mr320: _vm.bFullscreen && _vm.showTreasure,
                    ml280: _vm.bFullscreen && _vm.chatListVisible,
                  },
                  attrs: {
                    waitAnswer: _vm.waitAnswer,
                    clientType: _vm.getClientType,
                    title: _vm.title,
                    max: _vm.max,
                    hideHeadToolbar: _vm.bFullscreen && _vm.showTreasure,
                    bFullscreen: _vm.bFullscreen,
                  },
                  on: {
                    "update:waitAnswer": function ($event) {
                      _vm.waitAnswer = $event
                    },
                    "update:wait-answer": function ($event) {
                      _vm.waitAnswer = $event
                    },
                    getChatSetting: _vm.getChatSetting,
                    fullscreen: _vm.fullscreenChange,
                    close: _vm.closeAI,
                    showChatList: _vm.showChatList,
                  },
                }),
                _c("treasureDialog", {
                  attrs: { visible: _vm.showTreasure },
                  on: {
                    "update:visible": function ($event) {
                      _vm.showTreasure = $event
                    },
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }